/** Source identity survives the later move to the Russian live feed. */
export const isFeed7Id = (id: string): boolean => id.startsWith('f7:');
export const FEED7_BOOKS = ['kalshi', 'polymarket', '1xbet', '1win', 'leon', 'olimp', 'fonbet', 'betboom', 'winline'];
export function feed7ApiPath(path: string): string | null {
  return /^\/v1\/fork\/f7(?::|%3a)/i.test(path) ? `/feed7-api${path}` : null;
}

/** Keep the original bookmaker when the same f7 fork later appears in Russian live. */
export function feed7EventUrl(source: string, value: string | null | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value), host = url.hostname.replace(/^www\./, '');
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    if (source === '1xbet' && host === '1xbet.com' && /^\/ru\/(live|line)\/.+/.test(url.pathname)) return value;
    if (source === 'leon' && (host === 'leon.ru' || host === 'leonbets.net' || host.endsWith('.leonbets.net')) && /^\/(bets\/|events\/all\/)\S+/.test(url.pathname)) return value;
  } catch { /* malformed source address */ }
  return null;
}
